import React from 'react'
import { Link } from 'react-router-dom';
import '../We_Provide/We_Provide.css'
import { FaMobileAlt, FaComments, FaMoneyBillWave, FaShoppingCart, FaTasks, FaShieldAlt, FaVideo, FaBook } from 'react-icons/fa';
import SerIcon1 from '../../Img/ser-icon1.svg';
import SerIcon2 from '../../Img/ser-icon2.svg';
import SerIcon3 from '../../Img/ser-icon3.svg';
import SerIcon4 from '../../Img/ser-icon4.svg';


const We_Provide = () => {
  return (
    <div class="section harsafe-service-section section-padding-02">
        <div class="container">
            {/* <!-- Service Wrap Start --> */}
            <div class="service-wrap">
                <div class="section-title text-center">
                    <h3 class="sub-title">What We Provide</h3>
                    <h2 class="title">We Provide Truly Prominent Digital Solutions.</h2>
                </div>
                <div class="service-content-wrap">
                    <div class="row">
                        <div class="col-xl-3 col-sm-6">
                            {/* <!-- Service Item Start --> */}
                            <div class="service-item service-01">
                                <div class="service-img">
                                <FaMobileAlt />
                                    {/* <img src={SerIcon1} alt=""/> */}
                                </div>
                                <div class="service-content">
                                    <h3 class="title"><Link to="/Service">Innovative Mobile Solutions</Link></h3>
                                    <p>We offer state-of-the-art mobile applications designed to meet the needs of modern users.</p>
                                </div>
                            </div>
                            {/* <!-- Service Item End --> */}
                        </div>
                        <div class="col-xl-3 col-sm-6">
                            {/* <!-- Service Item Start --> */}
                            <div class="service-item">
                                <div class="service-img">
                                <FaComments />
                                {/* <img src={SerIcon2} alt=""/> */}
                                </div>
                                <div class="service-content">
                                    <h3 class="title"><Link to="/Service">Seamless Communication Tools</Link></h3>
                                    <p>Seamless Communication Tools: Our chat applications enable smooth, real-time communication for individuals and businesses.</p>
                                </div>
                            </div>
                            {/* <!-- Service Item End --> */}
                        </div>
                        <div class="col-xl-3 col-sm-6">
                            {/* <!-- Service Item Start --> */}
                            <div class="service-item service-03">
                                <div class="service-img">
                                <FaMoneyBillWave />
                                {/* <img src={SerIcon3} alt=""/> */}
                                </div>
                                <div class="service-content">
                                    <h3 class="title"><Link to="/Service">Secure Financial Management</Link></h3>
                                    <p>Secure Financial Management: Our UPI and financial apps ensure safe, efficient, and hassle-free transactions for all users.</p>
                                </div>
                            </div>
                            {/* <!-- Service Item End --> */}
                        </div>
                        <div class="col-xl-3 col-sm-6">
                            {/* <!-- Service Item Start --> */}
                            <div class="service-item">
                                <div class="service-img">
                                <FaShoppingCart />
                                {/* <img src={SerIcon4} alt=""/> */}
                                </div>
                                <div class="service-content">
                                    <h3 class="title"><Link to="/Service">User-Centric E-Commerce Platforms</Link></h3>
                                    <p>We deliver e-commerce solutions that enhance user experience and drive business growth.</p>
                                </div>
                            </div>
                            {/* <!-- Service Item End --> */}
                        </div>
                        <div class="col-xl-3 col-sm-6">
                            {/* <!-- Service Item Start --> */}
                            <div class="service-item service-05">
                                <div class="service-img">
                                <FaTasks />
                                {/* <img src={SerIcon4} alt=""/> */}
                                </div>
                                <div class="service-content">
                                    <h3 class="title"><Link to="/Service">Efficient Task Management</Link></h3>
                                    <p>Our tools streamline task organization and improve productivity for individuals and teams.</p>
                                </div>
                            </div>
                            {/* <!-- Service Item End --> */}
                        </div>
                        <div class="col-xl-3 col-sm-6">
                            {/* <!-- Service Item Start --> */}
                            <div class="service-item">
                                <div class="service-img">
                                <FaShieldAlt />
                                {/* <img src={SerIcon4} alt=""/> */}
                                </div>
                                <div class="service-content">
                                    <h3 class="title"><Link to="/Service">Robust Security Features</Link></h3>
                                    <p>We prioritize user safety with advanced security measures across all our applications.</p>
                                </div>
                            </div>
                            {/* <!-- Service Item End --> */}
                        </div>
                        <div class="col-xl-3 col-sm-6">
                            {/* <!-- Service Item Start --> */}
                            <div class="service-item service-07">
                                <div class="service-img">
                                <FaVideo />
                                {/* <img src={SerIcon4} alt=""/> */}
                                </div>
                                <div class="service-content">
                                    <h3 class="title"><Link to="/Service">Creative Reels Platform</Link></h3>
                                    <p>Engage with a modern reels app designed to foster creativity and fun interactions.</p>
                                </div>
                            </div>
                            {/* <!-- Service Item End --> */}
                        </div>
                        <div class="col-xl-3 col-sm-6">
                            {/* <!-- Service Item Start --> */}
                            <div class="service-item">
                                <div class="service-img">
                                <FaBook />
                                {/* <img src={SerIcon4} alt=""/> */}
                                </div>
                                <div class="service-content">
                                    <h3 class="title"><Link to="/Service">Comprehensive Hisab Book</Link></h3>
                                    <p>Simplify your accounting and financial tracking with our easy-to-use Hisab Book app.</p>
                                </div>
                            </div>
                            {/* <!-- Service Item End --> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Service Wrap End --> */}
        </div>
    </div>
  )
}

export default We_Provide